import { useEffect, useRef, useState } from "react";

export const useCountdown = () => {

    const [timeLeft, setTimeLeft] = useState(() => {
        const saved = localStorage.getItem("timeLeft");
        const parsed = parseInt(saved, 10);

        return (saved !== null && !Number.isNaN(parsed)) ? parsed : 1800000;
    });

    const [isActive, setIsActive] = useState(() => {
        const saved = localStorage.getItem("isActiveTimer");

        if (saved === null) return false;

        try {
            return JSON.parse(saved);
        } catch (error) {
            console.error("Error parsing isActiveTimer:", error);
            return false;
        }
    });

    const endTimeRef = useRef(!isNaN(localStorage.getItem("end_date")) ? parseInt(localStorage.getItem("end_date"), 10) : 0);

    useEffect(() => {
        let interval = null;

        if (isActive) {
            interval = setInterval(() => {
                const now = Date.now();
                const remaining = endTimeRef.current - now;

                if (remaining <= 0) {
                    setTimeLeft(0);
                    setIsActive(false);
                    clearInterval(interval);
                } else {
                    setTimeLeft(remaining);
                }
            }, 30);
        }

        return () => clearInterval(interval);
    }, [isActive]);

    useEffect(() => {
        localStorage.setItem("timeLeft", timeLeft);
    }, [timeLeft]);

    useEffect(() => {
        localStorage.setItem("isActiveTimer", JSON.stringify(isActive));
    }, [isActive]);

    const toggleTimer = () => {
        if (isActive) {
            setIsActive(false);
        } else {
            if (timeLeft > 0) {
                endTimeRef.current = Date.now() + timeLeft;
                localStorage.setItem("end_date", endTimeRef.current)
                setIsActive(true);
            }
        }
    };

    const stopTimer = () => {
        setIsActive(false);
        setTimeLeft(1800000);
    };

    const addTime = (amount, unit) => {
        let msToAdd = 0;
        switch (unit) {
            case 's': msToAdd = amount * 1000; break;
            case 'm': msToAdd = amount * 60 * 1000; break;
            case 'h': msToAdd = amount * 60 * 60 * 1000; break;
            case 'd': msToAdd = amount * 24 * 60 * 60 * 1000; break;
            default: msToAdd = 0;
        }

        if (isActive) {
            endTimeRef.current += msToAdd;
            setTimeLeft((prev) => prev + msToAdd > 0 ? prev + msToAdd : 0);
        } else {
            setTimeLeft((prev) => prev + msToAdd > 0 ? prev + msToAdd : 0);
        }
    };

    return { isActive, timeLeft, toggleTimer, stopTimer, addTime };
}